import * as React from 'react';
import { Badge, Button, Tag, Tooltip } from 'antd';
import { COLOR_PENDIENTE, COLOR_REGULARIZADA, COLOR_VALIDADA, COLOR_CANCELADA, COLOR_DUPLICADA, COLOR_RECHAZADA } from '../constants/constants';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Gestiona los colores del componente Tag en función del estado de una reserva
export const setTag = (state, idState, statusReason = '', rewardReferral = 0, currency = "EUR") => {
    const { t } = useTranslation(['remuneration']);
    let color = '#FFF';

    switch (idState) {
        case '1':
        case 'PEN':
        case 'INC': // ?
            color = COLOR_PENDIENTE;
            break;
        case '2':
        case 'REG':
            color = COLOR_REGULARIZADA;
            break;
        case '3':
        case 'VAL':
            color = COLOR_VALIDADA;
            break;
        case '4':
        case 'CAN':
            color = COLOR_CANCELADA;
            break;
        case '5':
        case 'DUP':
            color = COLOR_DUPLICADA;
            break;
        case '6':
        case 'REJ':
            color = COLOR_RECHAZADA;
            break;
        default:
            color = COLOR_PENDIENTE; // Better than invisible text...
    }

    var additionalInfo = <></>;

    if (idState == 'REJ' && statusReason.length > 0) {
        additionalInfo = <Tooltip title={statusReason}>
            <InfoCircleOutlined />
        </Tooltip>;
    }

    return (
        <div className="tag-content">
            {rewardReferral > 0 ?
                <Badge size='default' color='yellow'>
                    <Tooltip style={{ width: "100%" }} title={t('remuneration:reward-referral', { rewardReferral }) + ' ' + currency} color={'var(--primary-color)'} key={'var(--primary-color)'}>
                        <Button
                            className="tag-state"
                            style={{ width: "100%", textAlign: "center", backgroundColor: "#f6ffed", color: "#389e0d", background: "#f6ffed", borderColor: "#b7eb8f" }}
                            key={idState}>
                            {additionalInfo} {state}
                        </Button>
                    </Tooltip>

                </Badge> : <Tag
                    className="tag-state"
                    style={{ width: "100%", textAlign: "center" }}
                    color={color}
                    key={idState}
                >
                    {additionalInfo} {state}
                </Tag>}

        </div>

    );
}